function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useCallback, useMemo } from 'react';
import { isGroupHeader } from '../helpers';

var getStartingIndices = function getStartingIndices(groupedItems) {
  return groupedItems.reduce(function (indices, _, index) {
    if (index === 0) {
      // the first group will always map to the first item
      return indices.set(0, 0);
    }

    return indices.set(index, groupedItems.slice(0, index).reduce(function (acc, group) {
      return acc + group.items.length;
    }, 0));
  }, new Map());
};
/**
 * Strips the grouping out of dropdown items, transforming them into standard dropdown items, including a dummy item for the group header
 * @param groupedItems The grouped dropdown items
 * @returns flattened items without any context of grouping
 */


var flattenGroupItems = function flattenGroupItems(groupedItems, startingIndices) {
  return groupedItems.reduce(function (prev, curr, groupIndex) {
    var groupKey = "group".concat(groupIndex);
    var groupHeader = {
      label: curr.label,
      groupKey: groupKey,
      isGroupHeader: true
    };
    var itemsWithKey = curr.items.map(function (item, itemIndex) {
      return _objectSpread(_objectSpread({}, item), {}, {
        index: (startingIndices.get(groupIndex) || 0) + itemIndex,
        groupKey: groupKey
      });
    });
    return [].concat(_toConsumableArray(prev), [groupHeader], _toConsumableArray(itemsWithKey));
  }, []);
};

/**
 * A hook used to manage all logic needed for grouped items (menu sections/headings).
 * When using this hook, its return values should be used over any duplicates from other hooks
 */
export default (function (_ref) {
  var groupedItems = _ref.groupedItems;
  var startingIndices = useMemo(function () {
    return getStartingIndices(groupedItems);
  }, [groupedItems]);
  var flatItemsWithGroupHeaders = useMemo(function () {
    return flattenGroupItems(groupedItems, startingIndices);
  }, [groupedItems, startingIndices]);
  var getMenuItems = useCallback(function (filteredItems) {
    var filteredGroupedItems = groupedItems.map(function (itemGroup, groupIndex) {
      var startingIndex = startingIndices.get(groupIndex) || 0;
      return {
        label: itemGroup.label,
        items: itemGroup.items.reduce(function (acc, _, itemIndex) {
          var found = filteredItems.find(function (filteredItem) {
            return filteredItem.index === startingIndex + itemIndex;
          });

          if (!found) {
            return acc;
          }

          return [].concat(_toConsumableArray(acc), [found]);
        }, [])
      };
    }).filter(function (f) {
      return f.items.length > 0;
    });
    return flattenGroupItems(filteredGroupedItems, getStartingIndices(filteredGroupedItems));
  }, [groupedItems, startingIndices]);
  var flatItems = useMemo(function () {
    return flatItemsWithGroupHeaders.filter(function (item) {
      return !isGroupHeader(item);
    });
  }, [flatItemsWithGroupHeaders]);
  return {
    items: flatItems,
    isGroupHeader: isGroupHeader,
    getMenuItems: getMenuItems
  };
});
//# sourceMappingURL=useGroupedItems.js.map